App.showGPreview = ->
  $('#gpreview').show()
  viewer = new google.books.DefaultViewer\
  (document.getElementById('gpreview-body'), { showLinkChrome: false })
  viewer.load('ISBN:' + $('body').data('page-id'))
  false

App.setGPreview = (data) ->
  for i of data
    book = data[i]
    ean = book.bib_key
    gp = false
    if book.preview != 'noview'
      gp = true
      $('figure.cover').append('<img src="/images/google-preview.png" class="gpreview"/>')
      loadJS('https:\/\/www.google.com/books/jsapi.js', () -> google.books.load())
  if !ean
    ean = $('body').data('page-id')
  $('figure.cover').on 'click', ->
    if App.platform == 'phone' && gp
      loadInLightbox({
        url: '/view-product-images/' + ean + '/' + 'gp'
        onLoad: ->
          $('.lightbox').addClass('product-images')
          App.initCarousel()
          App.showGPreview()
      })
      return false
    else if App.platform != 'phone'
      loadInLightbox({
        url: '/view-product-images/' + ean + '/' + (if gp then 'gp' else '0')
        onLoad: ->
          $('.lightbox').addClass('product-images')
          App.initCarousel()
          if gp then App.showGPreview() else App.showFullSize(0)
      })
      return false
  return

App.setMultiImagesDimensions = ->
  if App.platform == 'phone'
    $phone_wrap = $('#phone-multi-images')
    $images_list = $('#phone-multi-images ul').first()
    wrap_width = $phone_wrap.width()

    $images_list.find('li').each ->
      $(this).css('padding-left', (wrap_width - $(this).width()) / 2)
      return
  return


$ ->
  ean = $('body').data('page-id')
  series = $('#series')
  if(series.length == 1)
    sid = series.attr('data-id')
  else
    sid = false

  if window.location.href.indexOf("#review") > -1
    if App.is_logged
      loadInLightbox({
        url: '/write-review/' + ean
        style: 'max-width: 45em'
        centered: true
        onLoad: ->
          App.initializeRating()
      })
    else
      $.get '/login?embed', (data, status) ->
        if status == 'success'
          html = '<div style="max-width: 25em; margin: 0 auto">\
          <h2>Intră în cont</h2><hr class="minor"><p style="margin-bottom: 1em">\
          Pentru a scrie o recenzie te rugăm să te conectezi</p>' + data + '</div>'
          $el = $(html)
          showInLightbox($el, { centered: true, style: 'max-width: 45em' })
          $('#login-button').on 'login', () ->
            $.get '/write-review/' + ean, (data, status) ->
              if status == 'success'
                $('.lightbox').removeClass('loginIframe')
                $('.lightbox').addClass('review')
                $('.lightbox-body').html(data)
                App.initializeRating()

  $('body').on 'click', '#write-review', ->
    loadInLightbox({
      url: '/write-review/' + ean
      style: 'max-width: 45em'
      centered: true
      onLoad: ->
        App.initializeRating()
    })
    return false
  $('body').on 'click', '#modify-review', ->
    loadInLightbox({
      url: '/write-review/' + ean
      style: 'max-width: 45em'
      centered: true
      onLoad: ->
        App.initializeRating()
    })
    return false

  $('#image-carousel').on 'click', 'li.normal>a', ->
    id = $(this).parent().attr('data-id')
    ean = $('body').attr('data-page-id')
    if App.platform == 'desktop'
      loadInLightbox({
        url: '/view-product-images/' + ean + '/' + id
        onLoad: ->
          App.showFullSize(id)
          $('.lightbox').addClass('product-images')
          App.initCarousel('#ligthbox-images')
      })
    else
      $.get(
        '/get-product-image/' + ean + '/' + id,
        (data) ->
          $('figure.cover').find('img').attr('src', data.src)
          $('figure.cover').find('img').attr('width', data.thumb.w)
          $('figure.cover').find('img').attr('height', data.thumb.h)
      )
    return false

  $('body').on 'click', '#save-cover', ->
    $form = $(this).closest('.form')
    data = { url: $form.find('input[name=url]').val(), ean13: $('body').data('page-id') }
    $.post '/edit/add-cover/' + ean, data, (json) ->
      if json.success
        window.location.reload()
  $('.newsletterAdd').on 'click', (e) ->
    id = $(e.target).data('id')
    nid = $(e.target).data('nid')
    type = $(e.target).data('type')
    if App.is_logged || nid != ""
      App.addToNewsletter(id, type)
    else
      loadInLightbox {
        url: '/insert-email/' + id + '/' + type
        centered: true }
    return false
  if App.is_logged
    if typeof(Storage) != undefined
      history = JSON.parse(localStorage.getItem('history'))
      if !history || history == 'null' || history == null || statusHtmlStorage('history') == 0
        history = []
      url = window.location.pathname
      $img = $('figure.cover img')
      if $img.length == 0
        ul = $('.multi-images ul :first-child')[0]
        $img = $(ul).find('img')
      cover = $img.attr('src')
      width = $img.attr('width')
      height = $img.attr('height')
      img_dim = ['/bf/', '/bx/', '/bb/', '/bs/', '/bl/', '/be/']
      title = $('span[itemprop="name"]').text()
      for i in img_dim
        cover = cover.replace(i, '/bs/')

      history2 = [{ title: title, url: url, img: cover, \
      w: Math.round(width / (height / 120)), h: 120 }]
      for i in history
        if history2.length > 30
          break
        if i.title.toString() != title.toString()
          history2.push i
      removeHtmlStorage 'history'
      setHtmlStorage('history', JSON.stringify(history2))
  else
    removeHtmlStorage 'history'
    $('#footer>.history').addClass 'hidden'

  $('body').on 'click', '#insert-subject', ->
    $('#email-error-message').hide()
    $form = $(this).closest('.form')
    email = $form.find('input[name=email-input-newsletter]').val()
    if !email.match Backbone.Validation.patterns.email
      $('#email-error-message').html("Vă rugăm să introduceți un email valid").show()
      return
    $(this).closest('.box').trigger('close')
    id = $form.find('input[name=email-input-newsletter]').attr('data-id')
    type = $form.find('input[name=email-input-newsletter]').attr('data-type')
    App.addToNewsletter(id, type)
    return false
  $('.price-box').on 'click', (e) ->
    loadInLightbox {
      url: '/exp-eco.html'
      style: 'max-width: 640px'
      centered: true }
    e.preventDefault()
    return
  $('.toggle-form').on 'click', ->
    el = $(this)
    id = el.attr('id')
    console.log('toggle-form: ' + id)
    $('.' + id).toggle()
    svg = el.find('svg')
    svg.svgSwap('ico-plus-squared-alt', 'ico-minus-squared-alt')
    false

  initResponsiveTable($('table.responsive'))
  $('#add2list-data').on 'click', '.add2this-list', (ev) ->
    App.add2list $(ev.currentTarget).data('id'), ean
    return false

  $('#add2list-data').on 'click', '#add2New-list', (ev) ->
    App.openCreateList(ean)
    return false

  $('#notification'). on 'click', (e) ->
    email = $('#email').val()
    phone = $('#phone').val()
    ean = $('body').data('page-id')
    emailPattern = Backbone.Validation.patterns.email
    phonePattern = /^\d{10}$/
    if $.trim(email) != "" && !email.match(emailPattern)
      $('#email-error').removeClass 'hidden'
      return
    if $.trim(phone) != "" && !phone.match(phonePattern)
      $('#phone-error').removeClass 'hidden'
      return
    if $.trim(email) == "" && $.trim(phone) == ""
      $('#notification-message').removeClass 'hidden'
    else
      $('#phone-error').addClass 'hidden'
      $('#email-error').addClass 'hidden'
      $('#notification-message').addClass 'hidden'
      $('#notification').hide()
      $('#sending-message').fadeIn()
      url = "/availability-notification/"
      if email != ""
        url = url + email + '/'
      if phone != ""
        url = url + phone + '/'
      url += ean
      $.get(
        url,
        (data) ->
          $('#sending-message').fadeOut()
          html = '<span>' + data.message + '</span>'
          $('#notification-success').append html
          if(data.success)
            $('#notification-container').addClass 'hidden'
            $('#notification-success').addClass 'success'
          else
            $('#notification-success').addClass 'error'
          $('#notification-success').removeClass 'hidden'
          return
      )
    return

  $('#add2list-data').on 'show', (ev, data) ->
    drop = data.jqDropdown
    $.get(
      '/user/lists.json',
      (data) ->
        items = '<li><a data-id="newList" id="add2New-list" href="#">\
        <svg class="ico right"><use href="/icons.svg#ico-pencil"/></svg>Listă nouă</a></li>'
        for i of data
          items += '<li><a data-id="' + data[i].id + '" class="add2this-list" href="#">'
          if(data[i].is_public)
            items += '<svg class="ico color-theme-6 right"><use href="/icons.svg#ico-eye"/></svg>'
          else
            items += '<svg class="ico color-theme-5 right">\
            <use href="/icons.svg#ico-eye-off"/></svg>'
          items += data[i].title + '</a></li>'
        tmp = drop.find('ul')
        if(tmp.length > 0)
          el = tmp[0]
          el.innerHTML = items
    )

  $('#remove-review').on 'click', ->
    $(this).parent().detach()
    $.post '/remove-review', { ean } , (json) ->
      if json.success
        trpop.add {
          title: _('Review')
          content: json.message
          type: 'notice' }
      else
        trpop.add {
          title: _('Review')
          content: json.message
          type: 'warning' }
      return
    false